<small class="debug">{{ me }}</small>
<form novalidate autocomplete="off" class="font-selector-form" [formGroup]="m_contGroup">

    <!-- Font Size Selector - First Priority -->
    <div class="font-size-section">
        <app-drop-number-selector
            [value]="m_contGroup.value.fontSize || 12"
            [min]="8"
            [max]="maxFontSize"
            [label]="'placeholder.fontSize' | transloco"
            [presetValues]="fontSizePresets"
            [showManualInput]="true"
            [placeholder]="'Font size'"
            (onChange)="onFontSizeChange($event)">
        </app-drop-number-selector>
    </div>

    <!-- Font Tools Section -->
    <div class="font-tools-section">
        <div class="tools-grid">
            <button mat-raised-button class="tool-btn font-preview-btn" (click)="dialogFontPreview()">
                <mat-icon>font_download</mat-icon>
                <span>{{ 'general.font' | transloco }}</span>
            </button>

            <button mat-raised-button class="tool-btn color-picker-btn" (click)="eyeDropper()">
                <mat-icon>colorize</mat-icon>
                <span>{{ 'general.pick' | transloco }}</span>
            </button>

            <div class="color-display-wrapper">
                <input #ignoredInput class="color-display" (click)="toggle=!toggle"
                       [style.background]="selectedFontColor"
                       [value]="selectedFontColor"
                       (colorPickerChange)="onColorChanged()"
                       (cpClosed)="onColorPickerClosed()"
                       [cpPosition]="'bottom'"
                       [cpIgnoredElements]="[ignoredInput]"
                       [readonly]="true"
                       [(cpToggle)]="toggle"
                       [(colorPicker)]="selectedFontColor"/>
            </div>
        </div>
    </div>

    <!-- Font Family Section -->
    @if (!m_hideFontFamily) {
        
         <div class="font-family-section">
             <mat-form-field class="font-family-field">
                 <mat-label>{{ 'placeholder.fontName' | transloco }}</mat-label>
                 <input matInput type="text" name="fontFamily"
                        placeholder="{{'placeholder.fontName' | transloco}}"
                        formControlName="fontFamily"
                        [matAutocomplete]="auto"
                        (blur)="checkFontFamily()"
                        autocomplete="off">
                 <a matSuffix aria-label="Clear" (click)="clearFontFamily()">
                     <mat-icon>close</mat-icon>
                 </a>
                 <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="selectedFontFamily($event)" (opened)="focusDropdown()">
                     <cdk-virtual-scroll-viewport [itemSize]="15" class="font-dropdown" #viewport>
                         <mat-option [value]="font" *cdkVirtualFor="let font of m_filteredFonts | async">
                             {{ font }}
                         </mat-option>
                     </cdk-virtual-scroll-viewport>
                 </mat-autocomplete>
             </mat-form-field>
         </div>
    }

    @if (!m_hideAlignment) {
        <div class="alignment-section">
            <div class="checkbox-group">
                @if (experienceLevel > experienceLevelType.BEGINNER) {
                    <mat-checkbox formControlName="autoScaling" (change)="changeCheckbox($event)">
                        <span class="checkbox-label">scale</span>
                    </mat-checkbox>
                }
                <mat-checkbox formControlName="wrap" (change)="changeCheckbox($event)">
                    <span class="checkbox-label">wrap</span>
                </mat-checkbox>
            </div>
            <mat-label>{{ 'general.horizontalAlign' | transloco }}</mat-label>
            <mat-button-toggle-group [value]="justificationValue" (change)="onJustificationValueChange(fontJustification.value)"
                                     #fontJustification="matButtonToggleGroup">
                <mat-button-toggle value="left">
                    <mat-icon>format_align_left</mat-icon>
                </mat-button-toggle>
                <mat-button-toggle value="center">
                    <mat-icon>format_align_center</mat-icon>
                </mat-button-toggle>
                <mat-button-toggle value="right">
                    <mat-icon>format_align_right</mat-icon>
                </mat-button-toggle>
                <mat-button-toggle value="justify">
                    <mat-icon>format_align_justify</mat-icon>
                </mat-button-toggle>
            </mat-button-toggle-group>

            @if (fontGroup.wrap && !m_hideVerticalAlignment) {
                <br/>
                <br/>
                <mat-label>{{ 'general.verticalAlign' | transloco }}</mat-label>
            }

            @if (!m_hideVerticalAlignment) {
                <div>
                    <mat-button-toggle-group [value]="justificationVerticalValue" (change)="onVerticalJustificationValueChange(fontVerticalJustification.value)"
                                             #fontVerticalJustification="matButtonToggleGroup">
                        <mat-button-toggle value="start">
                            <mat-icon>align_vertical_top</mat-icon>
                        </mat-button-toggle>
                        <mat-button-toggle value="center">
                            <mat-icon>vertical_distribute</mat-icon>
                        </mat-button-toggle>
                        <mat-button-toggle value="end">
                            <mat-icon>align_vertical_bottom</mat-icon>
                        </mat-button-toggle>
                    </mat-button-toggle-group>
                </div>
            }
        </div>
    }
    @if (m_showOnlyVertical) {
        <div>
            <mat-button-toggle-group [value]="justificationVerticalValue" (change)="onVerticalJustificationValueChange(fontVerticalJustification.value)"
                                     #fontVerticalJustification="matButtonToggleGroup">
                <mat-button-toggle value="start">
                    <mat-icon>align_vertical_top</mat-icon>
                </mat-button-toggle>
                <mat-button-toggle value="center">
                    <mat-icon>vertical_distribute</mat-icon>
                </mat-button-toggle>
                <mat-button-toggle value="end">
                    <mat-icon>align_vertical_bottom</mat-icon>
                </mat-button-toggle>
            </mat-button-toggle-group>
        </div>
    }
    <br/>
</form>


